import React from 'react';
import { ArrowLeftIcon } from '@shopify/polaris-icons';
import { handleMouseUpByBlurring } from '../../utilities/focus.js';
import { Button } from '../Button/Button.js';
function Breadcrumbs(_ref) {
  var _backAction$accessibi;
  var backAction = _ref.backAction;
  var content = backAction.content;
  var breadcrumbMarkup = /*#__PURE__*/React.createElement(Button, {
    key: content,
    url: 'url' in backAction ? backAction.url : undefined,
    onClick: 'onAction' in backAction ? backAction.onAction : undefined,
    onPointerDown: handleMouseUpByBlurring,
    icon: ArrowLeftIcon,
    accessibilityLabel: (_backAction$accessibi = backAction.accessibilityLabel) !== null && _backAction$accessibi !== void 0 ? _backAction$accessibi : content
  });
  return /*#__PURE__*/React.createElement("nav", {
    role: "navigation"
  }, breadcrumbMarkup);
}
export { Breadcrumbs };